import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import Fields from "./VentasSignInFields";

const ExpertosVentasSignIn = () => {
  return (
    <StyledFormContainer>
      <Typography variant="title" component="h2">
        ¡Bienvenid@!
      </Typography>
      <Typography variant="text" component="p">
        Inicia sesión para continuar
      </Typography>
      <Fields />
    </StyledFormContainer>
  );
};

const StyledFormContainer = styled.div`
  background: #fff;
  /* max-width: 550px; */
  flex: 1;
  padding: 40px 20px;
  border-radius: 10px;
  color: #114c97;
  > p {
    font-size: 20px;
  }

  @media (max-width: 991px) {
    max-width: none;
  }
`;

const StyledRegister = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  gap: 10px;
  > a {
    text-decoration: none;
    font-weight: 600;
    :hover {
      text-decoration: underline;
    }
  }
`;

export default ExpertosVentasSignIn;
